import { useState } from 'react';
import { FiFacebook  } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa";
import { PiTiktokLogoLight } from "react-icons/pi";
import { FaChevronDown } from "react-icons/fa";
import wetekup from '../assets/WETEKUP.svg'
import { analytics } from '../utils/analytics';
import { Link } from 'react-router-dom';

const Footer = () => {
    const [isNavigationOpen, setIsNavigationOpen] = useState(false);
    const [isContactOpen, setIsContactOpen] = useState(false);
    const handleEmailClick = () => {
        analytics.trackEvent('contact', { type: 'email', value: 'wetekup@gmail.com' });
    };

    const handleWhatsAppClick = () => {
        analytics.trackEvent('whatsapp', { type: 'whatsapp', value: '+216 28 655 323' });
    };

    const handleFacebookClick = () => {
        analytics.trackEvent('facebook_click', { url: 'https://www.facebook.com/p/WE-TEKUP-61570211227934/' });
    };

    const handleInstagramClick = () => {
        analytics.trackEvent('instagram_click', { url: 'https://www.instagram.com/we.tekup/' });
    };

    const handleLinkedInClick = () => {
        analytics.trackEvent('linkedin_click', { url: 'https://www.tiktok.com/@we.tekup?lang=fr' });
    };
    

    return(
        <footer className='w-full' style={{ backgroundColor: '#F6F6F6' }}>
            <div className='max-w-7xl mx-auto px-4 py-4 md:py-12'>
                {/* Mobile Layout */}
                <div className='md:hidden space-y-4'>
                    {/* Logo and Description */}
                    <div className='space-y-4 mb-6'>
                        <div className='flex items-center gap-2'>
                            <img src="/logowetekup.svg" alt="WeTekup" className="h-40 md:h-44 w-auto -my-16 max-md:-mx-2" />
                            {/* <span className='text-2xl font-bold text-gray-900'>
                                <span className="!font-light">We</span> Tekup
                            </span> */}
                        </div>
                        <p className='text-gray-500 text-sm leading-relaxed'>
                            Your trusted partner for innovative digital solutions, creative content, and professional photography services.
                        </p>
                    </div>

                    {/* Navigation Accordion */}
                    <div className='border-b border-gray-300 pb-3'>
                        <button 
                            onClick={() => setIsNavigationOpen(!isNavigationOpen)}
                            className='w-full flex items-center justify-between text-left'
                        >
                            <h3 className='text-lg font-bold text-gray-900'>Navigation</h3>
                            <FaChevronDown 
                                className={`text-gray-900 text-base transition-transform duration-300 ${
                                    isNavigationOpen ? 'rotate-180' : ''
                                }`}
                            />
                        </button>
                        <div 
                            className={`overflow-hidden transition-all duration-300 ${
                                isNavigationOpen ? 'max-h-96 mt-3' : 'max-h-0'
                            }`}
                        >
                            <div className='space-y-2'>
                                <Link to="/" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                    Home
                                </Link>
                                <Link to="/about" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                    About us
                                </Link>
                                <Link to="/services" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                    Our services
                                </Link>
                                <Link to="/studio" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                    Creative Studio
                                </Link>
                                <Link to="/contact" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                    Contact
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Contact Us Accordion */}
                    <div className='border-b border-gray-300 pb-3'>
                        <button 
                            onClick={() => setIsContactOpen(!isContactOpen)}
                            className='w-full flex items-center justify-between text-left'
                        >
                            <h3 className='text-lg font-bold text-gray-900'>Contact us</h3>
                            <FaChevronDown 
                                className={`text-gray-900 text-base transition-transform duration-300 ${
                                    isContactOpen ? 'rotate-180' : ''
                                }`}
                            />
                        </button>
                        <div 
                            className={`overflow-hidden transition-all duration-300 ${
                                isContactOpen ? 'max-h-96 mt-3' : 'max-h-0'
                            }`}
                        >
                            <div className='space-y-2'>
                                <p className='text-black text-sm'>Ain Zaghouan Sud</p>
                                <a 
                                    href="https://wa.me/21628655323" 
                                    onClick={handleWhatsAppClick} 
                                    target='_blank' 
                                    rel='noopener noreferrer' 
                                    className='block text-black hover:text-blue-600 transition-colors text-sm'
                                >
                                    +216 28 655 323
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* CTA Section */}
                    <div className='space-y-4 pt-2 w-full'>
                        <h3 className='text-lg font-bold text-gray-900 mb-6'>Need to start your project?</h3>
                        <Link 
                            to="/book-consultation"
                            className='w-2/3 bg-black text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors w-full text-center'
                        >
                            Book a consultation
                        </Link>
                    </div>

                    {/* Social Media Icons */}
                    <div className='flex items-center gap-3 pt-6'>
                        <a 
                            className='w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-blue-700' 
                            href='https://www.facebook.com/p/WE-TEKUP-61570211227934/' 
                            target='_blank' 
                            rel='noopener noreferrer' 
                            onClick={handleFacebookClick}
                        >
                            <FiFacebook size={22} className='text-white' />
                        </a>
                        <a 
                            className='w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-blue-700' 
                            href='https://www.instagram.com/we.tekup/' 
                            target='_blank' 
                            rel='noopener noreferrer' 
                            onClick={handleInstagramClick}
                        >
                            <FaInstagram size={22} className='text-white' />
                        </a>
                        <a 
                            className='w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-blue-700' 
                            href='https://www.tiktok.com/@we.tekup?lang=fr' 
                            target='_blank' 
                            rel='noopener noreferrer' 
                            onClick={handleLinkedInClick}
                        >
                            <PiTiktokLogoLight size={22} className='text-white' />
                        </a>
                    </div>
                </div>

                {/* Desktop Layout */}
                <div className='hidden md:grid grid-cols-4 gap-8'>
                    {/* Logo and Description */}
                    <div className='space-y-4'>
                        <div className='flex items-center gap-2'>
                            <img src="/logowetekup.svg" alt="WeTekup" className="h-40 md:h-44 w-auto -my-20 max-md:-mx-2" />
                            {/* <span className='text-2xl font-bold text-gray-900'><span className="!font-light"> We</span> Tekup</span> */}
                        </div>
                        <p className='text-black text-sm text-gray-500 leading-relaxed'>
                            Your trusted partner for innovative digital solutions, creative content, and professional photography services.
                        </p>
                        <div className='flex items-center gap-3'>
                            <a 
                                className='w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-blue-700' 
                                href='https://www.facebook.com/p/WE-TEKUP-61570211227934/' 
                                target='_blank' 
                                rel='noopener noreferrer' 
                                onClick={handleFacebookClick}
                            >
                                <FiFacebook  size={25} className='text-white' />
                            </a>
                            <a 
                                className='w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-blue-700' 
                                href='https://www.instagram.com/we.tekup/' 
                                target='_blank' 
                                rel='noopener noreferrer' 
                                onClick={handleInstagramClick}
                            >
                                <FaInstagram size={25} className='text-white text-sm' />
                            </a>
                            <a 
                                className='w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-blue-700' 
                                href='https://www.tiktok.com/@we.tekup?lang=fr' 
                                target='_blank' 
                                rel='noopener noreferrer' 
                                onClick={handleLinkedInClick}
                            >
                                <PiTiktokLogoLight size={25}  className='text-white text-sm' />
                            </a>
                        </div>
                    </div>

                    {/* Navigation */}
                    <div className='space-y-4'>
                        <h3 className='text-lg font-semibold text-gray-900'>Navigation</h3>
                        <div className='space-y-3'>
                            <Link to="/" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                Home
                            </Link>
                            <Link to="/about" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                About us
                            </Link>
                            <Link to="/services" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                Our services
                            </Link>
                            <Link to="/studio" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                Creative Studio
                            </Link>
                            <Link to="/contact" className='block text-black hover:text-blue-600 transition-colors text-sm'>
                                Contact
                            </Link>
                        </div>
                    </div>

                    {/* Contact Us */}
                    <div className='space-y-4'>
                        <h3 className='text-lg font-semibold text-gray-900'>Contact us</h3>
                        <div className='space-y-3'>
                            <p className='text-black text-sm'>Ain Zaghouan Sud</p>
                            <a 
                                href="https://wa.me/21628655323" 
                                onClick={handleWhatsAppClick} 
                                target='_blank' 
                                rel='noopener noreferrer' 
                                className='block text-black hover:text-blue-600 transition-colors text-sm'
                            >
                                +216 28 655 323
                            </a>
                        </div>
                    </div>

                    {/* CTA */}
                    <div className='space-y-4'>
                        <h3 className='text-lg font-semibold text-gray-900'>Need to start your project?</h3>
                        <Link 
                            to="/book-consultation"
                            className='inline-block bg-black text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors'
                        >
                            Book a consultation
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;